export const ingredientMeasurementUnitsRegexps = {
    get INGREDIENT_IMPERIAL_QUANTITY_ILLEGAL_CHARS_REGEXP() {
        return /[^0-9\/\s]+/g;
    },
    get INGREDIENT_IMPERIAL_QUANTITY_FORMAT_REGEXP() {
        return /(^[1-9][0-9]* \/ [1-9][0-9]*$)|(^[1-9][0-9]*$)/;
    },
};
